import React from 'react';
import { Appointmentbtn, Loader } from './styled';

export default function AppointmentButton(props) {
  const { desktopform, showLoader } = props;
  return (
    <Appointmentbtn>
      {showLoader ? (
        <Loader />
      ) : desktopform ? (
        'BOOK FREE CONSULTATION'
      ) : (
        'Book Appointment'
      )}
    </Appointmentbtn>
  );
}
